module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/copy.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("A Division of Simon & Schuster, Inc."), _c('br'), _vm._v("1230 Avenue of the Americas"), _c('br'), _vm._v("New York, NY 10020"), _c('br'), _c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.SimonandSchuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SimonandSchuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2009 by Mireille Guiliano")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. For information address Atria Books Subsidiary Rights Department, 1230 Avenue of the Americas, New York, NY 10020")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Atria Books hardcover edition October 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('strong', [_vm._v("ATRIA")]), _vm._v(" BOOKS and colophon are trademarks of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("For information about special discounts for bulk purchases, please contact Simon & Schuster Special Sales at 1-866-506-1949 or business@simonandschuster.com.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Simon & Schuster Speakers Bureau can bring authors to your live event. For more information or to book an event contact the Simon & Schuster Speakers Bureau at 1-866-248-3049 or visit our website at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.simonspeakers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonspeakers.com")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Designed by Jaime Putorti")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10   9   8   7   6   5   4   3   2   1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging- in- Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Guiliano, Mireille, date."), _c('br'), _vm._v("     Women, work, and the art of savoir faire: business sense and sensibility / Mireille Guiliano.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("1. Businesswomen. 2. Success in business. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("HD6053.G84 2009")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("650.1082--dc22")]), _vm._v(" "), _c('p', {
    staticClass: "textright"
  }, [_vm._v("2009011694")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 978-1-4165-8919-8")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 978-14165-9249-5 (ebook)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31eb9b2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm4_copy.vue
// module id = 72
// module chunks = 0